import { QueryFilters } from '@tanstack/react-query';
import { DashboardItemDto } from '@unistocks/proxy/axios-client';
import { dashboardGetCalendarDataQueryKey } from '@unistocks/proxy/axios-client/DashboardQuery';

export const queryFilter = ({ id }: DashboardItemDto): QueryFilters => ({
  queryKey: dashboardGetCalendarDataQueryKey(id)
});
